module.exports = __webpack_public_path__ + "static/img/college8.4e793be.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college8.jpeg
// module id = h46o
// module chunks = 45